import React, { FC } from "react";
import { createUseStyles, useTheme } from "react-jss";
import styles from "./styles";

interface Props {
  text?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  showBackground?: boolean;
  Icon?: React.FunctionComponent;
  children?: any;
  className?: string;
}

const MediaIcon: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);
  const theme = useTheme();

  const classes = useStyles({ theme, ...props });
  const { text, Icon, children, className } = props;

  return (
    <>
      {children || (
        <div className={classes.container}>
          {text && <span className={classes.text}>{text}</span>}
          {Icon && (
            <span
              className={className || classes.iconContainer}
              data-testid="svgStyle"
            >
              <Icon data-testid="svg" />
            </span>
          )}
        </div>
      )}
    </>
  );
};
MediaIcon.defaultProps = {
  text: "",
  showBackground: true,
  Icon: undefined,
  children: null,
  className: "",
};
export default MediaIcon;
try {
    // @ts-ignore
    MediaIcon.displayName = "MediaIcon";
    // @ts-ignore
    MediaIcon.__docgenInfo = { "description": "", "displayName": "MediaIcon", "props": { "text": { "defaultValue": { value: "" }, "description": "", "name": "text", "required": false, "type": { "name": "string" } }, "showBackground": { "defaultValue": { value: true }, "description": "", "name": "showBackground", "required": false, "type": { "name": "boolean" } }, "Icon": { "defaultValue": { value: "undefined" }, "description": "", "name": "Icon", "required": false, "type": { "name": "any" } }, "className": { "defaultValue": { value: "" }, "description": "", "name": "className", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/MediaIcon/MediaIcon.tsx#MediaIcon"] = { docgenInfo: MediaIcon.__docgenInfo, name: "MediaIcon", path: "src/shared/components/MediaIcon/MediaIcon.tsx#MediaIcon" };
}
catch (__react_docgen_typescript_loader_error) { }